// extracted by mini-css-extract-plugin
export var errorIcon = "_jt-1";
export var nameLogo = "_jt-0";